
export class SocketMessage {
bu: string;
domain: string;
infos: Object;
kind: string;
login: string;
origin: string;
originUuid: string;
status: string;
vision: string;
}

